<template>
  <button v-bind="$attrs" :class="getClassName(docStatus)">
    <template v-if="isTopPage">
      <div class="flex flex-row">
        <img
          v-if="docStatus != 0"
          :src="getIcon(docStatus)"
          width="20"
          height="20"
          class="ml-1 mr-1"
        />
        <div>
          <span class="text-lg font-bold" :class="[1, 2, 3, 6].includes(docStatus) ? 'text-green' : 'text-white'">領</span>
          <span class="text-sm font-bold" :class="[1, 2, 3, 6].includes(docStatus) ? 'text-green' : 'text-white'">収書</span>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="flex flex-row justify-center">
        <div
          :class="[1, 2, 3, 6].includes(docStatus) ? 'text-green' : 'text-white'"
        >
          <span class="text-lg font-bold">領</span>
          <span class="text-sm font-bold">収書</span>
        </div>
        <img
          v-if="docStatus != 0"
          :src="getIcon(docStatus)"
          width="20"
          height="20"
          class="ml-1 mr-1"
        />
        <app-receipt-status-text
          color="green"
          :status="docStatus"
        ></app-receipt-status-text>
      </div>
    </template>
  </button>
</template>
<script>
import { toRef } from 'vue'
import AppReceiptStatusText from '@/components/ui/AppReceiptStatusText'
import { useStatus } from '@/services/receipt/useStatus'

export default {
  name: 'AppReceiptStatusButton',

  components: {
    AppReceiptStatusText,
  },

  props: {
    status: {
      type: Number,
      default: null,
    },
    isTopPage: {
      type: Boolean,
      default: false,
    },
  },

  setup(props) {
    const docStatus = toRef(props, 'status')
    const { getClassName, getIcon } = useStatus()
    return { docStatus, getClassName, getIcon }
  },
}
</script>
